import {
  Component,
  OnInit,
  NgModule,
  OnChanges,
  ViewEncapsulation,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  Pipe,
  PipeTransform,
  Renderer,
} from "@angular/core";
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ListItem, MyException } from "./multiselect.model";
import { DropdownSettings } from "./multiselect.interface";
import { ClickOutsideDirective } from "./click-outside.directive";
import { ListFilterPipe } from "./list-filter-pipe.pipe";

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiComponent),
  multi: true,
};
const noop = () => {};

@Component({
  selector: "angular2-multiselect",
  templateUrl: "./multi.component.html",
  host: { "[class]": "defaultSettings.classes" },
  styleUrls: ["./multi.component.scss"],
  providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR],
})
export class MultiComponent implements OnInit, ControlValueAccessor {
  @Input()
  data: Array<any>;

  @Input()
  settings: DropdownSettings;

  @Input()
  customKey: string;

  @Input()
  customId: string;

  @Output("onSelect")
  onSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output("onDeSelect")
  onDeSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output("onSelectAll")
  onSelectAll: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  @Output("onDeSelectAll")
  onDeSelectAll: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  public selectedItems: Array<any>;
  public isActive: boolean = false;
  public isSelectAll: boolean = false;
  filter: ListItem = new ListItem();
  defaultSettings: DropdownSettings = {
    singleSelection: false,
    text: "Select",
    enableCheckAll: true,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: false,
    maxHeight: 300,
    badgeShowLimit: 999999999999,
    classes: "",
    disabled: false,
    searchPlaceholderText: "Search",
  };

  constructor(private el: ElementRef, private renderer: Renderer) {}
  ngOnInit() {
    this.settings = Object.assign(this.defaultSettings, this.settings);
  }
  ngDoCheck() {
    if (this.selectedItems) {
      if (
        this.selectedItems.length == 0 ||
        !this.data ||
        this.data.length == 0 ||
        this.selectedItems.length < this.data.length
      ) {
        this.isSelectAll = false;
      }
    }
  }
  onItemClick(item: any, index: number) {
    if (this.settings.disabled) {
      return false;
    }

    let found = this.isSelected(item);
    let limit =
      this.selectedItems.length < (this.settings.limitSelection as number)
        ? true
        : false;

    if (!found) {
      if (this.settings.limitSelection) {
        if (limit) {
          this.addSelected(item);
          this.onSelect.emit(item);
        }
      } else {
        this.addSelected(item);
        this.onSelect.emit(item);
      }
    } else {
      this.removeSelected(item);
      this.onDeSelect.emit(item);
    }
    if (this.isSelectAll || this.data.length > this.selectedItems.length) {
      this.isSelectAll = false;
    }
    if (this.data.length == this.selectedItems.length) {
      this.isSelectAll = true;
    }

    if (this.settings.singleSelection) {
      this.isActive = false;
    }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  writeValue(value: any) {
    if (value !== undefined && value !== null) {
      if (this.settings.singleSelection) {
        try {
          if (value.length > 1) {
            this.selectedItems = [value[0]];
            throw new MyException(404, {
              msg: "Single Selection Mode, Selected Items cannot have more than one item.",
            });
          } else {
            this.selectedItems = value;
          }
        } catch (e) {
          console.error(e.body.msg);
        }
      } else {
        if (this.settings.limitSelection) {
          this.selectedItems = value.splice(0, this.settings.limitSelection);
        } else {
          this.selectedItems = value;
        }
        if (
          this.selectedItems.length === this.data.length &&
          this.data.length > 0
        ) {
          this.isSelectAll = true;
        }
      }
    } else {
      this.selectedItems = [];
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
  trackByFn(index: number, item: any) {
    return item[this.customId];
  }
  isSelected(clickedItem: any) {
    let found = false;
    this.selectedItems &&
      this.selectedItems.forEach((item) => {
        if (clickedItem[this.customId] === item[this.customId]) {
          found = true;
        }
      });
    return found;
  }
  addSelected(item: any) {
    if (this.settings.singleSelection) {
      this.selectedItems = [];
      this.selectedItems.push(item);
    } else this.selectedItems.push(item);
    this.onChangeCallback(this.selectedItems);
  }
  removeSelected(clickedItem: any) {
    this.selectedItems &&
      this.selectedItems.forEach((item) => {
        if (clickedItem[this.customId] === item[this.customId]) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
        }
      });
    this.onChangeCallback(this.selectedItems);
  }
  toggleDropdown(evt: any, search) {
    setTimeout(() => {
      search.focus();
    }, 100);

    this.isActive = !this.isActive;
    evt.preventDefault();
    this.filter[this.customKey] = "";
  }
  closeDropdown() {
    this.isActive = false;
  }
  toggleSelectAll() {
    if (!this.isSelectAll) {
      this.selectedItems = [];
      this.selectedItems = this.data.slice();
      this.isSelectAll = true;
      this.onChangeCallback(this.selectedItems);
      this.onSelectAll.emit(this.selectedItems);
    } else {
      this.selectedItems = [];
      this.isSelectAll = false;
      this.onChangeCallback(this.selectedItems);
      this.onDeSelectAll.emit(this.selectedItems);
    }
  }
}
@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [MultiComponent, ClickOutsideDirective, ListFilterPipe],
  exports: [MultiComponent, ClickOutsideDirective, ListFilterPipe],
})
export class AngularMultiSelectModule {}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/multi/multi.component.ts